"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtoleService = void 0;
const http_1 = require("@angular/common/http");
const constants_1 = require("../constants");
class ExtoleService {
    constructor(http) {
        this.http = http;
    }
    createZone(tagName, elementid, isWireless, displayReferral) {
        // Retreive and set the extole object
        this.setExtoleObject();
        // Ensure createZone is avaliable
        if (this.checkCreateZoneAvailability()) {
            this.getCustomerReferralModel(isWireless).subscribe((customerReferralModel) => {
                this.extole.createZone({
                    name: tagName,
                    element_id: elementid,
                    data: {
                        first_name: customerReferralModel.firstName,
                        last_name: customerReferralModel.lastName,
                        email: customerReferralModel.email,
                        partner_user_id: customerReferralModel.partnerUserId,
                        labels: 'refer-a-friend-wireless'
                    }
                }, this.displayReferralContent(displayReferral));
            });
        }
    }
    /**
     * @returns displays the extole referral pop-up
     */
    displayReferralContent(displayReferral) {
        var _a, _b;
        // Check if the content has been requested to display
        if (displayReferral && ((_b = (_a = this.extole.q) === null || _a === void 0 ? void 0 : _a.history) === null || _b === void 0 ? void 0 : _b.length) <= 2) {
            setTimeout(() => {
                document.getElementById('extole_zone_refer_wireless_dashboard').click();
            }, 1000);
        }
    }
    /**
     * @returns the required customer referral model
     */
    getCustomerReferralModel(isWireless) {
        const url = constants_1.genericCustomerReferralEndpoint + '/?isWireless=' + isWireless;
        return this.http.get(url);
    }
    /**
     * @returns the availability of extole and its function
     */
    checkCreateZoneAvailability() {
        return typeof this.extole !== 'undefined' && this.extole.createZone && typeof this.extole.createZone === 'function';
    }
    /**
     * @returns Retreive and set the extole object
     */
    setExtoleObject() {
        // Grab adobe object
        const extoleObject = 'extole';
        this.extole = window[extoleObject];
    }
}
exports.ExtoleService = ExtoleService;
//# sourceMappingURL=extole.service.js.map